import { call, put, takeLatest } from 'redux-saga/effects';
import {
    loadedConsultations,
    REQUEST_CONSULTATIONS,
    SEARCH_REQUEST_CONSULTATIONS,
    REQUEST_CONSULTATIONS_PRACTITIONER,
    SEARCH_CONSULTATION_PRACTITIONER,
    REQUEST_DETAILS_CONSULTATION,
    SEARCH_CONSULTATION_PATIENT, unlockedConsultation, REQUEST_UNLOCK_CONSULTATION
} from '../actions/consultations.action';
import { Consultations, Practitioners, Patients } from '../api/index';
import {toast} from "react-toastify";
import {loadedPractitioners, UPDATE_PRACTITIONER, updatedPractitioner} from "../actions/practitioners.action";
import {updatePractitioner} from "./practitioners.saga";

export function* requestListConsultations() {
    try {
        let consultations = yield call(() => Consultations.all());
        yield put(loadedConsultations(consultations.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* searchConsultations(payload) {
    try {
        let consultations = null;
        if (payload.data.search.length > 0) {
            consultations =yield call(() => Consultations.search(payload.data.search));
        } else {
            consultations = yield call(() => Consultations.all());
        }

        yield put(loadedConsultations(consultations.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* requestConsultationsPractitioner({payload}) {
    try {
        let consultation = yield call(() => Practitioners.getConsultations(payload));
        yield put(loadedConsultations(consultation.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* searchConsultationPractitioner(payload) {
    try {
        let consultation = [];
        if (payload.data.search.length > 0) {
            consultation = yield call(() => Practitioners.searchConsultation(payload.data));
        } else {
            consultation = yield call(() => Practitioners.getConsultations(payload.data.uuid));
        }
        yield put(loadedConsultations(consultation.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* searchConsultationPatient(payload) {
    try {
        let consultation = [];
        if (payload.data.search.length > 0) {
            consultation = yield call(() => Patients.searchConsultations(payload.data));
        } else {
            consultation = yield call(() => Patients.getConsultations(payload.data.uuid));
        }
        yield put(loadedConsultations(consultation.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* requestDetailsConsultation({payload}) {
    try {
        let details = yield call(() => Consultations.details(payload));
        yield put(loadedConsultations(details.data));
    } catch (err) {
        toast.error(err.response.data.message);
    }
}

export function* unlockConsultation({payload}) {
    try {
        yield call(() => Consultations.unlock(payload));
        yield put(unlockedConsultation());
        toast.success('Consultation débloquée')
    } catch (e) {
        let errors = e.response.data.details;
        for (e of errors) {
            toast.error(e['field'] + ' : ' + e['message']);
        }
    }
}

export function* watchRequestListConsultations(){
    yield takeLatest(REQUEST_CONSULTATIONS, requestListConsultations);
}

export function* watchSearchRequestConsultations(){
    yield takeLatest(SEARCH_REQUEST_CONSULTATIONS, searchConsultations)
}

export function* watchRequestConsultationsPractitioner(){
    yield takeLatest(REQUEST_CONSULTATIONS_PRACTITIONER, requestConsultationsPractitioner);
}

export function* watchSearchConsultationPractitioner(){
    yield takeLatest(SEARCH_CONSULTATION_PRACTITIONER, searchConsultationPractitioner)
}

export function* watchRequestDetailsConsultation(){
    yield takeLatest(REQUEST_DETAILS_CONSULTATION, requestDetailsConsultation)
}

export function* watchSearchConsultationPatient(){
    yield takeLatest(SEARCH_CONSULTATION_PATIENT, searchConsultationPatient)
}

export function* watchUnlockConsultation() {
    yield takeLatest(REQUEST_UNLOCK_CONSULTATION, unlockConsultation)
}


// WEBPACK FOOTER //
// ./src/sagas/consultations.saga.js